import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, TransitionGroup as _TransitionGroup, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-728d94e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "items-section" }
const _hoisted_2 = { class: "item-card" }
const _hoisted_3 = { class: "item-card-preview" }
const _hoisted_4 = { class: "item-card-image" }
const _hoisted_5 = { class: "item-card-image" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "item-card-details" }
const _hoisted_8 = { class: "item-card-details-name" }
const _hoisted_9 = { class: "item-card-details-actions" }
const _hoisted_10 = { class: "actions-dropdown-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "QUANTITY:", -1))
const _hoisted_12 = ["onClick"]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_14 = { class: "item-card-details-total" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "total-label" }, "ITEM TOTAL", -1))
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 0,
  class: "players-details"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Quantity")
], -1))
const _hoisted_19 = {
  key: 1,
  class: "players-details"
}
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "Name"),
  /*#__PURE__*/_createElementVNode("th", null, "Number"),
  /*#__PURE__*/_createElementVNode("th", null, "Size"),
  /*#__PURE__*/_createElementVNode("th", null, "Quantity")
], -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, {
      name: "list",
      tag: "div"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderedItems, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_swiper, {
                  id: `swiper_${index}`,
                  effect: 'flip',
                  loop: true,
                  grabCursor: true,
                  pagination: true,
                  navigation: true,
                  modules: _ctx.modules
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_swiper_slide, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(item.alias), {
                            logo: item.logo,
                            productColors: item.colors,
                            details: item.details,
                            text: item.text,
                            activePlayer: 
                      item.playersDetails ? item.playersDetails[0] : null
                    ,
                            cheetaLogo: item.cheetaLogo
                          }, null, 8, ["logo", "productColors", "details", "text", "activePlayer", "cheetaLogo"]))
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_swiper_slide, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_5, [
                          (_openBlock(), _createBlock(_resolveDynamicComponent(`${item.alias}_back`), {
                            logo: item.logo,
                            productColors: item.colors,
                            text: item.text,
                            cheetaLogo: item.cheetaLogo,
                            activePlayer: 
                      item.playersDetails ? item.playersDetails[0] : null
                    ,
                            details: item.details
                          }, null, 8, ["logo", "productColors", "text", "cheetaLogo", "activePlayer", "details"]))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["id", "modules"]),
                _createElementVNode("div", {
                  class: "item-card-preview-edit",
                  onClick: ($event: any) => (_ctx.editDesign(item))
                }, " EDIT DESIGN ", 8, _hoisted_6)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, _toDisplayString(item.name
                  ? item.name.toUpperCase()
                  : "SPECIFY NAME THROUGH ADMIN PANEL TO DISPLAY IT HERE"), 1),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _hoisted_11,
                    _createVNode(_component_InputNumber, {
                      title: 
                    item.type === 't_shirt'
                      ? `You can change quantity of this product via designer tool. Click 'EDIT DESIGN' to go to designer tool.`
                      : ''
                  ,
                      "onUpdate:modelValue": [($event: any) => (
                    _ctx.changeQTY($event, item.id, item.databaseId)
                  ), ($event: any) => ((item.quantity) = $event)],
                      disabled: item.type === 't_shirt',
                      style: {"width":"100%"},
                      modelValue: item.quantity,
                      mode: "decimal",
                      allowEmpty: false,
                      min: item.minQty
                    }, null, 8, ["title", "onUpdate:modelValue", "disabled", "modelValue", "min"])
                  ]),
                  _createElementVNode("div", {
                    class: "actions-remove",
                    onClick: ($event: any) => (_ctx.deleteItem(item))
                  }, "REMOVE", 8, _hoisted_12)
                ]),
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  (_ctx.priceLoading.loading && _ctx.priceLoading.id === item.id)
                    ? (_openBlock(), _createBlock(_component_Skeleton, {
                        key: 0,
                        style: {"width":"55px","height":"1.5rem"}
                      }))
                    : (_openBlock(), _createElementBlock("div", _hoisted_16, " $" + _toDisplayString(_ctx.getPrice(item.price, item.quantity, item.addons)), 1))
                ])
              ])
            ]),
            (item.sizes)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _createVNode(_component_Accordion, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccordionTab, { header: "SIZES" }, {
                        default: _withCtx(() => [
                          _createElementVNode("table", null, [
                            _hoisted_18,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.sizes, (size) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: size.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(size.size.name), 1),
                                _createElementVNode("td", null, _toDisplayString(size.quantity), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            (item.playersDetails)
              ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                  _createVNode(_component_Accordion, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_AccordionTab, { header: "PLAYERS DETAILS" }, {
                        default: _withCtx(() => [
                          _createElementVNode("table", null, [
                            _hoisted_20,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.playersDetails, (player) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: player.id
                              }, [
                                _createElementVNode("td", null, _toDisplayString(player.name), 1),
                                _createElementVNode("td", null, _toDisplayString(player.number), 1),
                                _createElementVNode("td", null, _toDisplayString(player.size ? player.size.name : "N/A"), 1),
                                _createElementVNode("td", null, _toDisplayString(player.quantity), 1)
                              ]))
                            }), 128))
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]))
              : _createCommentVNode("", true),
            _hoisted_21
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}